module.exports = __webpack_public_path__ + "static/media/YB5F17_1.93a04ae2.jpg";